import React, { useEffect, useRef } from 'react';
import { assets } from '../constants/theme';

export default function Gallery() {
  const containerRef = useRef(null);

  useEffect(() => {
    // Observer for scroll reveals
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fadeIn');
        }
      });
    }, { threshold: 0.1 });

    const items = document.querySelectorAll('.gallery-item');
    items.forEach((item, index) => {
      // Stagger the transitions based on HTML order
      item.style.transitionDelay = `${0.1 + (index * 0.1)}s`;
      observer.observe(item);
    });

    return () => observer.disconnect();
  }, []);

  const coffees = [
    { name: 'Kenyan AA Whole Beans', roast: 'Light-Medium Roast', flavor: 'Blackcurrant, Jasmine, Citrus', img: assets.galleryImg1 },
    { name: 'Savana Signature Ground', roast: 'Medium Roast', flavor: 'Caramel, Dark Chocolate, Berries', img: assets.galleryImg2 },
    { name: 'Arabica A Grade Beans', roast: 'Medium Roast', flavor: 'Chocolate, Caramel, Nuts', img: assets.galleryImg3 },
    { name: 'Savana Blend Ground Packets', roast: 'Medium-Dark', flavor: 'Brown Sugar, Spice, Subtle Fruit', img: assets.galleryImg4 },
  ];

  const s = {
    section: {
      padding: '8rem 6%',
      backgroundColor: '#FAF7F2', // offWhite
    },
    header: {
      textAlign: 'center',
      marginBottom: '4rem',
    },
    title: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '2.5rem',
      fontWeight: 400,
      color: '#1C1209', // charcoal
      marginBottom: '1rem',
    },
    subtitle: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.9rem',
      fontWeight: 500,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      color: '#A0693A', // caramel
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '3rem 2rem', // more vertical gap
    },
    card: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      cursor: 'pointer',
    },
    imgContainer: {
      width: '100%',
      aspectRatio: '3/4',
      overflow: 'hidden',
      marginBottom: '1.5rem',
      backgroundColor: '#EDE4D8', // fog for loading state
    },
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: 'transform 0.6s ease',
    },
    name: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '1.1rem',
      fontWeight: 600,
      color: '#1C1209', // charcoal
      marginBottom: '0.2rem',
    },
    roast: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.8rem',
      color: '#6B3A2A', // mahogany
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      marginBottom: '0.5rem',
    },
    flavor: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '1rem',
      fontStyle: 'italic',
      color: '#8C5E3C', // terra
    }
  };

  return (
    <section id="gallery" style={s.section}>
      <div style={s.header}>
        <div style={s.subtitle}>Current Offerings</div>
        <h2 style={s.title}>Selected for Character</h2>
      </div>

      <div style={s.grid} ref={containerRef}>
        {coffees.map((c, i) => (
          <div 
            key={i} 
            className="gallery-item preFade" 
            style={s.card}
            onMouseEnter={e => {
              const img = e.currentTarget.querySelector('img');
              if (img) img.style.transform = 'scale(1.04)';
            }}
            onMouseLeave={e => {
              const img = e.currentTarget.querySelector('img');
              if (img) img.style.transform = 'scale(1)';
            }}
          >
            <div style={s.imgContainer}>
              <img src={c.img} alt={c.name} style={s.img} loading="lazy" />
            </div>
            <div style={s.name}>{c.name}</div>
            <div style={s.roast}>{c.roast}</div>
            <div style={s.flavor}>{c.flavor}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
